export default __webpack_public_path__ + "static/media/standings.dadfbc95.png";